import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHDivisionGet = async (credentials, data) => {
    const body = {
        service: "RNHDivisionGet",
        params: {
            rnhDivisionId: data?.id || null,
            rnhEstablecimientoId: data?.hospitalId || null,
            rnhDepartamentoId: data?.departamentoId || null,
            soloDisponibles: data?.disponibles || ''
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
